import { createGlobalStyle } from "styled-components";
import reset from "styled-reset";

export const GlobalStyle = createGlobalStyle`
  ${reset}

  html, body, #root {
    height: 100vh;
  }

  body {
    background: ${({ theme }) => theme.pageBackground};
    color: ${({ theme }) => theme.text};
    transition: all 0.3s;
    font-family: 'Baloo Tamma 2', cursive;
  }
`;

export const lightTheme = {
  pageBackground: "#fff",
  navigationBackground: "#dedede",
  navigationLogoBackground: "#c7c7c7",
  navigationTextHover: "#d81159",
  themeSwitchOnColor: "#c7c7c7",
  themeSwitchOffColor: "#101010",
  themeSwitchBoxShadowColor: "#d81159",
  text: "#363537",
  toggleBorder: "#FFF",
  background: "#363537",
};

export const darkTheme = {
  pageBackground: "#1d1d1d",
  navigationBackground: "#181818",
  navigationLogoBackground: "#101010",
  navigationTextHover: "#d81159",
  themeSwitchOnColor: "#9a9a9a",
  themeSwitchOffColor: "#4c4c4c",
  themeSwitchBoxShadowColor: "#d81159",
  text: "#FAFAFA",
  toggleBorder: "#6B8096",
  background: "#999",
};
